<template>
  <div class="rounded-lg bg-depth-1 p-8 text-center">
    <div
      v-if="isChecking"
      class="size-10 rounded-full border-4 border-depth-3 border-t-brand animate-spin mx-auto"
    ></div>
    <template v-else>
      <div
        class="mx-auto flex size-16 items-center justify-center rounded-full bg-depth-2 mb-4"
      >
        <svg
          class="size-8 text-mouse"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M16.5 10.5V6.75a4.5 4.5 0 10-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H6.75a2.25 2.25 0 00-2.25 2.25v6.75a2.25 2.25 0 002.25 2.25z"
          />
        </svg>
      </div>
      <h2 class="text-xl font-bold text-mouse uppercase">
        {{ t('checkout/step/auth/title') }}
      </h2>
      <p class="mt-2 text-rhino">
        {{ t('checkout/step/auth/description') }}
      </p>
      <common-button size="custom" class="mt-6 px-8 py-3" @click="handleLogin">
        {{ t('checkout/step/auth/sign-in') }}
      </common-button>
    </template>
  </div>
</template>

<script setup lang="ts">
import useAuth from '~/composables/useAuth';

const { t, locale } = useI18n();
const route = useRoute();
const router = useRouter();
const authStore = useAuthStore();

const { login } = useAuth();

const isChecking = ref(true);
const planId = computed(() => route.params.planId as string);

const handleLogin = () => {
  const redirectPath = `/${locale.value}/checkout/${planId.value}/step/3`;
  login(redirectPath);
};

onMounted(() => {
  if (authStore.isAuthenticated) {
    router.replace({
      params: { ...route.params, stepNumber: '3' },
    });
  } else {
    isChecking.value = false;
  }
});
</script>
